'use strict';
import * as tools from './tools.js';

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
window.bootstrap = require('bootstrap');

import lazyframe from "lazyframe";
lazyframe(".lazyframe", {
    autoplay: true,
});

import Swiper, {Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper = new Swiper('.swiper__full', {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    navigation : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    },
    on: {
        init: function () {
            let headerHeight = document.querySelector('header').offsetHeight;
            this.el.style.height = (innerHeight - headerHeight) + 'px';
            tools.pauseSliderVideos(this);
            tools.playSliderVideos(this);
        },
        transitionStart: function(){
            tools.pauseSliderVideos(this);
        },
        transitionEnd: function(){
            tools.playSliderVideos(this);
        },
    },
});

//Control cambio bg header y actives en home
let isHome = (document.querySelector('body').classList.contains('body-home')),
    mainHead =  (isHome) ? document.querySelector('.swiper__home') : document.querySelector('.main-head'),
    mainNav = document.getElementById('main-nav-container'),
    mainNavLink = mainNav.querySelectorAll(':scope a'),
    head = document.querySelector('header'),
    mainHeadFinish = mainHead.offsetHeight,
    mainNavFinish = mainNav.offsetHeight,
    haveSectionMenu = false,
    selfLink = document.querySelectorAll('.self-link');

if(isHome) {
    let actualUrl = document.URL;
    if(actualUrl.indexOf('#') !== -1) {
       const hash = actualUrl.split('#')[1];
        selfLink.forEach((i) => {
            if (i.getAttribute('href').indexOf('#' + hash) !== -1) i.classList.add('active');
            else i.classList.remove('active');
        })
        mainNavLink.forEach((i) => {
            if (i.getAttribute('href').indexOf('#' + hash) !== -1){
                i.classList.add('active');
                head.classList.add('with-bg');
            }
            else i.classList.remove('active');
        })
    }
}



document.addEventListener('scroll',(e) => {
    if(window.scrollY + mainNavFinish >= mainHeadFinish) head.classList.add('with-bg');
    else head.classList.remove('with-bg');
})

//Cierre de menu en home cuando se navega entre secciones
selfLink.forEach((i) => {
    i.addEventListener('click',(e) => {
        selfLink.forEach((x) => {
            x.classList.remove('active');
        })
        i.classList.add('active');
        const eventClick = new Event('click');
        document.getElementById('offcanvasRight').querySelector(':scope .btn-close').dispatchEvent(eventClick);
    })
})

//Navegacion interna home fuera de moviles
mainNavLink.forEach((i) => {
    i.addEventListener('click',(e) => {
        mainNavLink.forEach((x) => {
            x.classList.remove('active');
        })
        i.classList.add('active');
    })
})